import React, { useState } from "react";
import RequestTable from "../RequestTable";
import Paginate from "../../../../../../../../../global components/Paginate/Pagination";
import SearchInput from "../../../../../../../../../global components/Forms/SearchInput/SearchInput";
import s from "./TableWrapper.module.scss";
import { swrFetcher } from "../../../../../../../../../libs/api/Endpoints";
import { UseAuthToken } from "../../../../../../../../../libs/api/userSession";
import { PaginatedApiLogType } from "../../../../../../../../../libs/Utils/Types/APIManagement";
import useSWR from "swr";
import ReusablePopover from "../../../../../../../../../global components/Popover/ReuseablePopover";
import FilterPopOverContent from "../FilterPopOverContent";
import { FilterIcon } from "../../../../../../../../../global components/Icons/FilterIcon";
function TableWrapper() {
  const token = UseAuthToken();
  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageItems, setPageItems] = useState(100);
  const [status, setStatus] = useState<"success" | "client" | "server">();
  const { data, isLoading } = useSWR<PaginatedApiLogType, any, any>(
    token
      ? [
          "api/admin/api-keys/logs",
          token,
          {
            ...(searchValue && { search: searchValue }),
            ...(status && { filter: status }),
            ...(currentPage && { page: currentPage }),
            ...(pageItems && { limit: pageItems }),
          },
        ]
      : null,
    swrFetcher,
  );
  const handleSearch = (value: string) => {
    setSearchValue(value);
    // You can add your search logic here, e.g., fetching data based on the search term
  };
  const handlePageChange = (page: number, size: number) => {
    setCurrentPage(page);
    setPageItems(size);
  };
  return (
    <div className={s.tableWrapper}>
      <div className={s.head}>
        <div className={s.searchInput}>
          <SearchInput
            style={{ width: "100%", height: "100%" }}
            placeholder="Search by user name or request ID..."
            width={332}
            height={45}
            handleSearch={handleSearch}
          />
        </div>
        <div className={s.filterWrapper}>
          <ReusablePopover
            content={
              <FilterPopOverContent setStatus={setStatus} status={status} />
            }
            trigger={"hover"}
          >
            <button className={s.filter}>
              <FilterIcon className={s.filterIcon} />
              <p>Filter</p>
            </button>
          </ReusablePopover>
          <Paginate
            onChange={handlePageChange}
            total={data?.pagination.totalItems || 0}
            pageSize={pageItems}
          />
        </div>
      </div>
      <RequestTable data={data?.data || []} loading={isLoading} />
    </div>
  );
}

export default TableWrapper;
